export default "__VITE_ASSET__GtjQEeop__"